/*
 * Define a form page forcing the user to enter an email address
 * to receive a confirmation email.
 */
import * as yup from 'yup'
import css from './pages.module.css'
import { emailYup } from '../validators'
import { joinClassNames } from '../utilities'

export const confirmationEmailOpDivPage = propOverrides => {
  const props = {
    pageId: 'confirmation_email_page',
    fieldName: 'confirmation_email',
    required: true,
    label: '',
    hint: '',
    className: '',
    labelClassName: '',
    ...propOverrides
  }

  const validation = yup.object().shape({
    [props.fieldName]: emailYup(props.required)
  })

  const classNames = joinClassNames(css.printReview, props.className)

  return {
    id: props.pageId,
    validation: validation,
    fields: [
      {
        type: 'text',
        name: props.fieldName,
        label: props.label,
        hint: props.hint,
        labelClassName: props.labelClassName,
        className: classNames
      }
    ]
  }
}
